export enum RoleTypes {
    none = 0,
    admin = 1,
    user = 2,
    extern = 3, /* nicht fürs Frontend */
    streetworker = 4, /* nicht fürs Frontend */
    adminReadOnly = 5,
    trackerRegistor = 6, /* nicht fürs Frontend */
    UserReadOnly = 7,
    systemUser = 8, /* nicht fürs Frontend */
    userReports = 9 
}

export function getRoleTypesString(roleType: RoleTypes): string {
    switch (roleType) {
        case RoleTypes.admin:
            return 'Admin';
        case RoleTypes.adminReadOnly:
            return 'AdminReadOnly';
        case RoleTypes.extern:
            return 'Extern';
        case RoleTypes.none:
            return 'None';
        case RoleTypes.streetworker:
            return 'Monteur';
        case RoleTypes.user:
            return 'User';
        case RoleTypes.UserReadOnly:
            return 'UserReadOnly';
        case RoleTypes.trackerRegistor:
            return 'TrackerRegistor'
        case RoleTypes.systemUser:
            return 'SystemUser';
        case RoleTypes.userReports:
            return 'UserReports';
    }
}
